import ENVIRONMENT_VARIABLES from '../../../constants/environmentVariables';

export enum RestAPINames {
  BRASS_API = 'brassApi',
  PAPI = 'papi',
}

/**
 * API Information interface defining endpoints for different services
 * Uses camelCase naming convention for consistency
 */
export interface APIInfo {
  environment: string;
  [RestAPINames.BRASS_API]: string;
  [RestAPINames.PAPI]: string;
}

/**
 * Default configuration for backend REST API endpoints based on environment.
 *
 * Note: While these are hardcoded for backward compatibility, the preferred approach
 * is to override them using environment variables as described in the getApiEndpoint function.
 */
export const RestApiConfig: APIInfo[] = [
  {
    environment: 'dev',
    brassApi: 'https://beta.dasfinbrassapi.device.finance.amazon.dev',
    papi: 'https://alpha.fintech-papi.device.finance.amazon.dev',
  },
  {
    environment: 'alpha',
    brassApi: 'https://beta.dasfinbrassapi.device.finance.amazon.dev',
    papi: 'https://alpha.fintech-papi.device.finance.amazon.dev',
  },
  {
    environment: 'beta',
    brassApi: 'https://beta.dasfinbrassapi.device.finance.amazon.dev',
    papi: 'https://beta.fintech-papi.device.finance.amazon.dev',
  },
  {
    environment: 'prod',
    brassApi: 'https://dasfinbrassapi.device.finance.amazon.dev',
    papi: 'https://fintech-papi.device.finance.amazon.dev',
  },
];

/**
 * Get API endpoint for a specific service
 *
 * @param apiName - Name of the API service (e.g., 'brassApi', 'papi')
 * @returns The API endpoint URL or null if not found
 *
 * @example
 * // Get brass API endpoint for the current environment
 * const endpoint = getApiEndpoint('brassApi');
 */
export const getApiEndpoint = (apiName: RestAPINames): string | null => {
  // Get current environment from environment variables
  const { Stage } = ENVIRONMENT_VARIABLES.env;

  // Find configuration for current environment
  const config = RestApiConfig.find((config) => config.environment === Stage.toLowerCase());
  if (!config) {
    return null;
  }

  return config[apiName] || null;
};
